export default __webpack_public_path__ + "locales/sl/EmbeddingPanel.json?hash=d699bdf380ab646d8b39b39d47e43cbe";